import { useEffect, useState } from 'react';

declare const document: {
  documentMode: boolean;
};

/**
 * NOTE: This exists in a hook because nextjs will throw errors if
 * the window object is executed in a non browser context. The hook guarantees
 * it can be shared and only be interpreted in a browser environment.
 */
export default function useIeCheck(): boolean {
  const [isIe, setIsIe] = useState(false);
  useEffect(() => {
    setIsIe(!!window.MSInputMethodContext && !!document.documentMode);
  }, []);

  return isIe;
}
